export const UnitDashedLine = ({ id }: { id: string }) => {
  return (
    <div
      className="relative ml-6 mt-18 hidden h-[calc(100%-122px)] w-[4px] pb-8 xl:block "
      id={`${id}-dashed-line`}
    >
      <svg
        width="4"
        height="100%"
        className="absolute left-0 top-0"
        id={`${id}-dashed-line-svg`}
      >
        <defs>
          <pattern
            id={`dotted-pattern-${id}`}
            width="4"
            height="25"
            patternUnits="userSpaceOnUse"
          >
            <rect width="4" height="16" rx="2" fill="#E4E7F2" />
          </pattern>
        </defs>
        <rect width="4" height="100%" fill={`url(#dotted-pattern-${id})`} />
      </svg>
    </div>
  )
}
